import { FC } from "react";
import SectionGridFilterCard from "./SectionGridFilterCard";
import { Helmet } from "react-helmet";
import { useData } from "data/data-provider";
import { useNavigate } from "react-router-dom";

export interface ListingCarPageProps {
  className?: string;
}

const AvailableCarsPage: FC<ListingCarPageProps> = ({ className = "" }) => {
  const { companyDetails } = useData();
  const navigate = useNavigate();
  return (
    <div
      className={`nc-ListingCarPage relative overflow-hidden ${className}`}
      data-nc-id="ListingCarPage"
    >
      <Helmet>
        <title>{companyDetails?.seo_title}</title>
      </Helmet>

      <div className="container relative">
        <div className="mt-2">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="focus:outline-none"
            aria-label="Go back"
          >
            <svg
              width="45"
              height="45"
              viewBox="0 0 45 45"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M22.5 41.25C32.8553 41.25 41.25 32.8553 41.25 22.5C41.25 12.1446 32.8553 3.74998 22.5 3.74998C12.1447 3.74998 3.75 12.1446 3.75 22.5C3.75 32.8553 12.1447 41.25 22.5 41.25Z"
                stroke="currentColor"
                strokeWidth="2.8125"
                className="text-text-color"
              />
              <path
                d="M25.3125 30C25.3125 30 19.6875 24.4762 19.6875 22.5C19.6875 20.5235 25.3125 15 25.3125 15"
                stroke="currentColor"
                strokeWidth="2.8125"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-text-color"
              />
            </svg>
          </button>
        </div>
        <SectionGridFilterCard className="mt-12 pb-24 lg:pb-28" />
      </div>
    </div>
  );
};

export default AvailableCarsPage;
